import NavBar from "@/view/components/nav-bar/nav-bar";
import { ref } from "@vue/reactivity";
import { closeToast, showConfirmDialog, showLoadingToast, showToast } from "vant";
import RouterUtil from "@/utils/RouterUtil";
import StorageUtil from "@/utils/StorageUtil";
import SettingApi from "@/api/setting-api";
export default {
  name: "Setting",
  components: {
    NavBar
  },
  setup() {
    const title = ref("设置");
    const setting = ref(SettingApi.getDefaultConfig());
    const isWatchSetting = ref(false);
    return {
      title,
      setting,
      isWatchSetting
    };
  },
  watch: {
    setting: {
      handler: function () {
        if (this.isWatchSetting) {
          this.setUserSetting();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getUserSetting();
  },
  methods: {
    goProfile() {
      RouterUtil.go("/user/profile", false, this.$route.path);
    },
    goRidePreference() {
      RouterUtil.go("/setting/ride-preference", false, this.$route.path);
    },
    clearCacheClick() {
      showConfirmDialog({
        title: "清除缓存",
        message: "清除缓存会清除运行中的临时数据，这些并不影响实际使用，若出现运行问题，可以尝试清除缓存，确定清除吗？",
        confirmButtonText: "确定"
      }).then(() => {
        StorageUtil.clearCache();
        setTimeout(function () {
          showToast("缓存清理完成");
        }, 500);
      }).catch(() => {
        // on cancel
      });
    },
    prohibitProxyClick() {
      if (this.setting.isProhibitProxy) {
        this.isWatchSetting = false;
        showConfirmDialog({
          message: "开启此项后，任何人都将无法为你叫车，确定开启吗？",
          confirmButtonText: "确定"
        }).then(() => {
          this.isWatchSetting = true;
          this.setting.isProhibitProxy = true;
          this.setUserSetting();
        }).catch(() => {
          this.isWatchSetting = true;
          this.setting.isProhibitProxy = false;
        });
      }
    },
    getUserSetting() {
      const that = this;
      showLoadingToast({
        duration: 0,
        // overlay: true,
        forbidClick: true,
        message: '正在加载...'
      });
      SettingApi.getSetting().then(function (result) {
        if (result.setting) {
          that.setting = result.setting;
        }
      }).catch(function (error) {}).finally(function () {
        that.isWatchSetting = true;
        closeToast();
      });
    },
    setUserSetting() {
      SettingApi.setSetting(this.setting);
    }
  }
};